"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Cloner = _interopRequireDefault(require("../../utils/Cloner"));
var _Sorter = _interopRequireDefault(require("../../common/Sorter"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--down/16.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--up/16.js"));
var _ListenOnClickOutside = require("../../common/Listeners/ListenOnClickOutside");
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.multiselect-dropdown {\n  position: relative;\n  width: 100%;\n  margin-bottom: 1.5rem; }\n  .multiselect-dropdown:focus {\n    outline: none; }\n  .multiselect-dropdown .bx--label {\n    color: #4c4c4c; }\n  .multiselect-dropdown button.bx--list-box__field svg.hidden {\n    display: none; }\n  .multiselect-dropdown button.bx--tag__close-icon svg {\n    color: #ffffff; }\n  .multiselect-dropdown .bx--list-box__menu {\n    background: white;\n    max-height: 220px; }\n    .multiselect-dropdown .bx--list-box__menu:focus {\n      outline: 0; }\n    .multiselect-dropdown .bx--list-box__menu .bx--list-box__menu-item--active {\n      background: #d4d4d4; }\n    .multiselect-dropdown .bx--list-box__menu .bx--list-box__menu-item.disabled:hover {\n      cursor: initial; }\n    .multiselect-dropdown .bx--list-box__menu .bx--list-box__menu-item.disabled .bx--checkbox-label {\n      opacity: 0.4;\n      cursor: initial; }\n    .multiselect-dropdown .bx--list-box__menu .bx--list-box__menu-item .bx--checkbox-label {\n      font-size: 12px;\n      padding-top: 4.5px;\n      color: #4c4c4c; }\n  .multiselect-dropdown .multiselect-dropdown-tags {\n    position: absolute;\n    top: 28px;\n    left: 13px;\n    display: flex;\n    overflow: hidden; }\n";
  const fileName = "MultiselectDropdown_MultiselectDropdown";
  const element = document.querySelector("style[data-sass-component='MultiselectDropdown_MultiselectDropdown']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MultiselectDropdown = props => {
  const typeSearchTimeoutMilliseconds = 1000;
  const [tagsContainerWidth, setTagsContainerWidth] = (0, _react.useState)('0px');
  const [searchStartedTimestamp, setSearchStartedTimestamp] = (0, _react.useState)(0);
  const [searchingValue, setSearchingValue] = (0, _react.useState)('');
  const ref = (0, _react.useRef)(null);
  (0, _ListenOnClickOutside.listenOnClickOutside)(ref, () => {
    onClose();
    if (props.isOpen) {
      props.toggle(false);
    }
  });
  const resizeTagsContainer = () => {
    const dropdown = document.getElementById(props.id);
    const button = dropdown.querySelector('button');
    const buttonStyles = window.getComputedStyle(button);
    const buttonPaddingLeft = parseInt(buttonStyles.paddingLeft);
    const buttonPaddingRight = parseInt(buttonStyles.paddingRight);
    const newTagsContainerWidth = button.clientWidth - buttonPaddingLeft - buttonPaddingRight + 'px';
    setTagsContainerWidth(newTagsContainerWidth);
  };
  (0, _react.useEffect)(() => {
    resizeTagsContainer();
    scrollToInput();
  });
  (0, _react.useLayoutEffect)(() => {
    const event = 'resize';
    window.addEventListener(event, resizeTagsContainer);
    const disableListener = () => window.removeEventListener(event, resizeTagsContainer);
    return disableListener;
  });
  const renderActiveItemsTags = () => {
    const isClosable = !props.disabled;
    const tags = props.items.filter(item => item.active).map(item => {
      return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Tag, {
        key: item.id,
        type: 'high-contrast',
        filter: isClosable,
        onClose: isClosable ? () => {
          /**
           * delayed, to fix that items are being closed on removing item. happens because
           * onclick-outside handler thinks that we clicked outside, due to element removal.
           */
          setTimeout(e => onClickItem(e, item), 1);
        } : undefined
      }, item.label);
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'multiselect-dropdown-tags',
      style: {
        maxWidth: tagsContainerWidth
      }
    }, tags);
  };
  const createClassNames = () => {
    let classNames = ['multiselect-dropdown'];
    // if (props.disabled) {
    //   classNames.push('bx--list-box--disabled');
    // }
    if (props.className) {
      classNames.push(props.className);
    }
    return classNames;
  };
  const scrollToInput = () => {
    const element = document.getElementById(props.id);
    const scrollable = element.querySelector('.bx--list-box__menu');
    const options = element.querySelectorAll('.bx--list-box__menu-item');
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const label = option.querySelector('span.bx--checkbox-label');
      const isMatchingOption = label.innerHTML.toLowerCase().startsWith(searchingValue.toLowerCase());
      if (isMatchingOption) {
        scrollable.scrollTop = option.offsetTop;
        return;
      }
    }
  };
  const onKeyDown = event => {
    const isSingleInput = event.key.length === 1; // it may be "Enter", "Alt", etc.
    props.onKeyDown && props.onKeyDown(event);
    if (!isSingleInput) {
      return;
    }
    const shouldInitializeSearch = Date.now() - searchStartedTimestamp > typeSearchTimeoutMilliseconds;
    if (shouldInitializeSearch) {
      setSearchStartedTimestamp(Date.now());
      setSearchingValue(event.key);
      return;
    }
    setSearchingValue(searchingValue + event.key);
  };
  const onClickItem = (event, item) => {
    if (props.disabled) {
      return;
    }
    const updatedItems = props.items.map(propItem => {
      const isMatchingItem = propItem.id === item.id;
      if (isMatchingItem) {
        const newItem = _Cloner.default.clone(item);
        newItem.active = !newItem.active;
        return newItem;
      }
      return propItem;
    });
    props.onClickItem(event, item, updatedItems);
  };
  const sortItems = () => {
    const labelSortedItems = props.ignoreSort ? props.items : _Sorter.default.sortByProperty(props.items, 'label');
    const enabledItems = labelSortedItems.filter(item => !item.disabled);
    const disabledItems = labelSortedItems.filter(item => item.disabled);
    return enabledItems.concat(disabledItems);
  };
  const items = _react.default.useMemo(() => sortItems(), [props.items]);
  const renderOptions = () => items.map(item => {
    const itemClasses = ['bx--list-box__menu-item'];
    if (item.active) {
      itemClasses.push('bx--list-box__menu-item--active');
    }
    if (item.disabled === true) {
      itemClasses.push('disabled');
    }
    const enabled = !item.disabled;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.id,
      className: itemClasses.join(' '),
      onClick: enabled ? event => onClickItem(event, item) : null
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "bx--list-box__menu-item__option"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "bx--checkbox-wrapper"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "bx--checkbox-label",
      "data-contained-checkbox-state": item.active
    }, item.label))));
  });
  const renderDropdownOptions = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'bx--multi-select'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "bx--list-box__menu"
    }, renderOptions()));
  };
  const createDynamicListBoxProps = () => {
    const dynamicProps = {};
    if (props.invalidText) {
      dynamicProps['data-invalid'] = true;
    }
    return dynamicProps;
  };
  const onClose = () => {
    if (props.isOpen && props.onClose) {
      props.onClose();
    }
  };

  // using list-box classes to replicate MultiSelect from carbon. carbon's component misses functionality that we need.
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: createClassNames().join(' '),
    onKeyDown: onKeyDown,
    id: props.id,
    tabIndex: "-1" // need tabIndex to let work onKeyDown on safari
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "bx--label",
    onClick: () => {
      if (props.disabled) {
        return;
      }
      onClose();
      props.toggle(!props.isOpen);
    }
  }, _LabelFactory.default.create(props.label, props.required)), /*#__PURE__*/_react.default.createElement("div", _extends({
    className: 'bx--list-box'.concat(props.disabled ? ' bx--list-box--disabled' : ''),
    onClick: () => {
      if (props.disabled) {
        return;
      }
      onClose();
      props.toggle(!props.isOpen);
    }
  }, createDynamicListBoxProps()), /*#__PURE__*/_react.default.createElement("button", {
    className: "bx--list-box__field"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'bx--list-box__menu-icon'
  }, /*#__PURE__*/_react.default.createElement(_2.default, {
    className: !props.isOpen ? 'hidden' : ''
  }), /*#__PURE__*/_react.default.createElement(_.default, {
    className: props.isOpen ? 'hidden' : ''
  })))), props.invalidText && /*#__PURE__*/_react.default.createElement("div", {
    className: 'bx--form-requirement'
  }, props.invalidText), renderActiveItemsTags(), props.isOpen && renderDropdownOptions());
};
MultiselectDropdown.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool,
  toggle: _propTypes.default.func.isRequired,
  items: _propTypes.default.array.isRequired,
  onClickItem: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func,
  invalidText: _propTypes.default.string,
  required: _propTypes.default.bool,
  className: _propTypes.default.string,
  type: _propTypes.default.string
};
MultiselectDropdown.defaultProps = {
  type: 'MultiselectDropdown' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = MultiselectDropdown;